import * as Marionette from 'backbone.marionette';
import app from 'app';
import $ from 'jquery';
import * as Cookie from '@component/common/src/util/Cookie';
import { getSession, setSession/* , removeSession */ } from '@component/common/src/util/ClientSideStorage';

export default Marionette.ItemView.extend({
  initialize() {
    // removeSession('notifications-read'); // for debugging
    // removeSession('which-notifications-read'); // for debugging
    app.channel.on('display:account:notifications', this.handleDisplayEvent.bind(this));
    app.channel.on('focus:indicator:elem', this.focusIndicatorElem.bind(this));
    app.channel.on('cards:update', this.cardAddedToWallet.bind(this));
    const self = this;
    app.channel.on('render:account:notifications:icon', () => {
      const icon = $(self.$el.selector);
      self.$el = icon;
      self.render();
      icon.on('click', this.renderModal.bind(this));
    });
    // get xapi data
    this.getNotifications(this.handleNotificationsData.bind(this), this.handleNotificationsError.bind(this));
    this.drawerShown = false;
  },
  ui: {
    icon: '#notifications-icon',
  },
  events: {
    'click @ui.icon': 'renderModal',
  },
  handleDisplayEvent() {
    if (!this.drawer) {
      this.createDrawer();
    }
    this.drawer.showDrawer();
  },
  createDrawer() {
    app.channel.on('re:render:account:notifications', this.drawer.showDrawer.bind(this.drawer));
    this.drawerShown = true;
  },
  getNotifications(success, error) {
    this.model.fetch({
      cache: false,
      success,
      error,
    });
    // const mock = require('../../../mock/notificationResponse.json');
    // setTimeout(() => {
    //   success(this.model, mock);
    // }, 1000);
  },
  handleNotificationsData(model, resp) {
    const { userNotifications } = resp;

    // if response is empty
    if (!userNotifications) {
      this.model.set('noNotifications', true);
      this.updateWithData(0);
      return;
    }

    let notificationCount = 0;
    if (userNotifications.addCardToWallet) {
      this.model.set('addCardToWallet', true);
      notificationCount += 1;
    }
    if (userNotifications.linkPropCardsToFusion && userNotifications.linkPropCardsToFusion.cardNumbers) {
      this.showLinkPropCardToFusion(userNotifications.linkPropCardsToFusion.cardNumbers);
      notificationCount += userNotifications.linkPropCardsToFusion.cardNumbers.length;
    }
    if (userNotifications.loyaltyRewardCards && userNotifications.loyaltyRewardCards.length) {
      this.showRewardCards(userNotifications.loyaltyRewardCards);
      notificationCount += userNotifications.loyaltyRewardCards.length;
    }
    if (userNotifications.makePropCardDefault) {
      this.model.set('makePropDefault', true);
      notificationCount += 1;
    }
    if (userNotifications.enrollLoyalty) {
      this.model.set('enrollRewards', true);
      notificationCount += 1;
    }
    if (userNotifications.orderInfo && userNotifications.orderInfo.length) {
      userNotifications.orderInfo.forEach((notif) => {
        if (notif.notificationCode === 524) {
          notif.updatePayment = true;
        }
      });
      this.model.set('orderNotifs', userNotifications.orderInfo);
      notificationCount += userNotifications.orderInfo.length;
    }
    // MCOM only
    if (userNotifications.starRewardsDowngradeInfo) {
      this.model.set('starRewardsDowngradeInfo', userNotifications.starRewardsDowngradeInfo);
      notificationCount += 1;
    }
    this.model.set('noNotifications', notificationCount === 0);
    this.updateWithData(notificationCount);
    this.model.set('notificationsDataReceived', true);
  },
  handleNotificationsError() {
    // how do we handle error? show 'no new notifications'?
    this.model.set('noNotifications', true);
    this.model.set('notificationsDataReceived', true);
  },
  updateWithData(notificationCount) {
    if (this.drawerShown) {
      this.createDrawer();
    } else {
      if (notificationCount) {
        this.model.set('notificationCount', notificationCount);
      }
      // check if inbox has already been read
      const sessionId = Cookie.get('secure_user_token');
      const alreadyRead = sessionId && (getSession('notifications-read') === sessionId);

      // check for any new notifications
      const curr = {
        addCardToWallet: this.model.get('addCardToWallet'),
        makePropDefault: this.model.get('makePropDefault'),
        enrollRewards: this.model.get('enrollRewards'),
        fusionCards: this.model.get('fusionCards'),
        rewardCards: this.model.get('rewardCards'),
        orderNotifs: this.model.get('orderNotifs'),
      };
      let prev = getSession('which-notifications-read');
      if (prev) {
        prev = JSON.parse(prev);
        const newNotififications = prev && (
          (!prev.addCardToWallet && curr.addCardToWallet) ||
          (!prev.makePropDefault && curr.makePropDefault) ||
          (!prev.enrollRewards && curr.enrollRewards) ||
          (!prev.fusionCards && curr.fusionCards) ||
          (!prev.rewardCards && curr.rewardCards) ||
          ((prev.fusionCards && curr.fusionCards) &&
            (prev.fusionCards.length < curr.fusionCards.length)) ||
          ((prev.rewardCards && curr.rewardCards) &&
            (prev.rewardCards.length < curr.rewardCards.length)) ||
          ((prev.orderNotifs && curr.orderNotifs) &&
            (prev.orderNotifs.length < curr.orderNotifs.length))
        );
        this.model.set('showIndicator', !alreadyRead || newNotififications);
      } else {
        this.model.set('showIndicator', true);
      }
      this.render();
    }
  },
  showLinkPropCardToFusion(cardNumbers) {
    const fusionCards = [];
    cardNumbers.forEach((cardNumber) => {
      fusionCards.push({
        cardNumber,
      });
    });
    this.model.set('fusionCards', fusionCards);
  },
  showRewardCards(cards) {
    let id = 0;
    const rewards = [];
    // xAPI will order the cards correctly for us
    cards.forEach((card) => {
      rewards.push({
        amount: card.amount,
        expiring: card.expiringSoon,
        expiration: card.expirationDate,
        id,
      });
      id += 1;
    });
    this.model.set('rewardCards', rewards);
  },
  renderModal(e) {
    e.preventDefault();
    // don't do anything until xapi data is back
    if (!this.model.get('notificationsDataReceived')) {
      return;
    }
    if (!this.notifications) {
      app.channel.trigger('display:account:notifications');
      this.notifications = true;
    } else {
      app.channel.trigger('re:render:account:notifications');
    }
    // set which notifications have been seen
    setSession('which-notifications-read', JSON.stringify({
      addCardToWallet: this.model.get('addCardToWallet'),
      makePropDefault: this.model.get('makePropDefault'),
      enrollRewards: this.model.get('enrollRewards'),
      fusionCards: this.model.get('fusionCards'),
      rewardCards: this.model.get('rewardCards'),
      orderNotifs: this.model.get('orderNotifs'),
    }));
    // remove indicator # once inbox is opened
    setSession('notifications-read', Cookie.get('secure_user_token'));
    this.model.set('showIndicator', false);
    this.render();
  },
  focusIndicatorElem() {
    $('#notifications-icon').focus();
  },
  cardAddedToWallet(args) {
    // check that this is a wallet update
    if (args[0] !== 'wallet') {
      return;
    }
    // destroy drawer
    if (this.drawer) {
      this.drawer.destroy();
      this.drawer = null;
      this.notifications = false;
    }
    this.drawerShown = false;
    // no longer show Add To Wallet message
    // check if it was the last one
    this.model.set({
      addCardToWallet: false,
      noNotifications: !(this.model.get('notificationCount') - 1),
    });
  },
});
